// // // // import React, { useState, useEffect } from "react";
// // // // import { Link, useLocation } from "react-router-dom";
// // // // import { motion, AnimatePresence } from "framer-motion";

// // // // // Navigation items data
// // // // const NAV_ITEMS = [
// // // //   { title: "Home", path: "/" },
// // // //   { title: "About Us", path: "/about" },
// // // //   {
// // // //     title: "Services",
// // // //     path: "/services&product",
// // // //     submenu: [
// // // //       { title: "Data Build", path: "/dataBuildservices" },
// // // //       { title: "U.S Mortgage Underwriting", path: "/mortgageservices" },
// // // //       { title: "Customer Support Services", path: "/customersupportservices" },
// // // //       { title: "Webinar Registration", path: "/Webinarregistrationservices" },
// // // //       { title: "Lead Generation", path: "/leadgenration" },
// // // //     ],
// // // //   },
// // // //   { title: "Career", path: "/career" },
// // // //   { title: "Contact Us", path: "/contact" },
// // // // ];

// // // // // Navbar Component
// // // // const Navbar = () => {
// // // //   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
// // // //   const [servicesOpen, setServicesOpen] = useState(false);
// // // //   const [isScrolled, setIsScrolled] = useState(false);
// // // //   const location = useLocation();

// // // //   useEffect(() => {
// // // //     const handleScroll = () => {
// // // //       setIsScrolled(window.scrollY > 10);
// // // //     };
// // // //     window.addEventListener("scroll", handleScroll);
// // // //     return () => window.removeEventListener("scroll", handleScroll);
// // // //   }, []);

// // // //   // Helper to detect active route
// // // //   const isActive = (path) => location.pathname === path;

// // // //   // Only one dropdown open at a time, so control in mobile menu
// // // //   const handleServiceToggle = () => setServicesOpen((open) => !open);

// // // //   // Close menus on route change (desktop)
// // // //   const handleNavLinkClick = () => {
// // // //     setMobileMenuOpen(false);
// // // //     setServicesOpen(false);
// // // //   };

// // // //   return (
// // // //     <nav
// // // //       className={`fixed w-full z-50 transition-all duration-300 ${
// // // //         isScrolled
// // // //           ? "bg-black/90 backdrop-blur-md py-3 shadow-xl"
// // // //           : "bg-transparent py-5"
// // // //       }`}
// // // //     >
// // // //       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// // // //         <div className="flex justify-between h-16">
// // // //           <div className="flex items-center">
// // // //             <div className="flex-shrink-0 flex items-center">
// // // //               <Link
// // // //                 to="/"
// // // //                 className="text-2xl font-bold text-green-400 hover:text-green-300 transition"
// // // //                 aria-label="Quadrangle Solutions Home"
// // // //                 onClick={handleNavLinkClick}
// // // //               >
// // // //                 Quadrangle<span className="text-green-500">.</span>
// // // //               </Link>
// // // //             </div>
// // // //             <div className="hidden md:ml-10 md:flex md:space-x-8">
// // // //               {NAV_ITEMS.map((item, idx) => (
// // // //                 <div key={idx} className="relative group">
// // // //                   {item.submenu ? (
// // // //                     <>
// // // //                       <button
// // // //                         type="button"
// // // //                         className={`flex items-center gap-1 font-medium ${
// // // //                           location.pathname.startsWith("/dataBuildservices") ||
// // // //                           location.pathname.startsWith(
// // // //                             "/customersupportservices"
// // // //                           ) ||
// // // //                           location.pathname.startsWith(
// // // //                             "/Webinarregistrationservices"
// // // //                           ) ||
// // // //                           location.pathname.startsWith("/leadgenration")
// // // //                             ? "text-green-400"
// // // //                             : "text-gray-300 hover:text-green-400"
// // // //                         } transition`}
// // // //                         aria-haspopup="true"
// // // //                         aria-expanded={servicesOpen ? "true" : "false"}
// // // //                         onClick={() => setServicesOpen(!servicesOpen)}
// // // //                         onMouseEnter={() => setServicesOpen(true)}
// // // //                         onMouseLeave={() => setServicesOpen(false)}
// // // //                       >
// // // //                         {item.title}
// // // //                         <svg
// // // //                           className={`w-4 h-4 transform transition-transform ${
// // // //                             servicesOpen ? "rotate-180" : ""
// // // //                           }`}
// // // //                           fill="none"
// // // //                           stroke="currentColor"
// // // //                           strokeWidth={2}
// // // //                           viewBox="0 0 24 24"
// // // //                           strokeLinecap="round"
// // // //                           strokeLinejoin="round"
// // // //                         >
// // // //                           <path d="M19 9l-7 7-7-7"></path>
// // // //                         </svg>
// // // //                       </button>
// // // //                       <AnimatePresence>
// // // //                         {servicesOpen && (
// // // //                           <motion.div
// // // //                             initial={{ opacity: 0, y: 6 }}
// // // //                             animate={{ opacity: 1, y: 0 }}
// // // //                             exit={{ opacity: 0, y: 6 }}
// // // //                             transition={{ duration: 0.18 }}
// // // //                             onMouseEnter={() => setServicesOpen(true)}
// // // //                             onMouseLeave={() => setServicesOpen(false)}
// // // //                             className="absolute top-full left-0 mt-2 w-56 bg-gray-800 rounded-md shadow-lg border border-green-700/30 py-2 z-50"
// // // //                             role="menu"
// // // //                             aria-label="submenu"
// // // //                           >
// // // //                             {item.submenu.map((sub, subIdx) => (
// // // //                               <div key={subIdx} role="none">
// // // //                                 <Link
// // // //                                   to={sub.path}
// // // //                                   className={`block px-4 py-2 text-gray-300 hover:bg-green-900/30 hover:text-green-400 transition ${
// // // //                                     isActive(sub.path)
// // // //                                       ? "font-semibold text-green-400"
// // // //                                       : ""
// // // //                                   }`}
// // // //                                   role="menuitem"
// // // //                                   onClick={handleNavLinkClick}
// // // //                                 >
// // // //                                   {sub.title}
// // // //                                 </Link>
// // // //                               </div>
// // // //                             ))}
// // // //                           </motion.div>
// // // //                         )}
// // // //                       </AnimatePresence>
// // // //                     </>
// // // //                   ) : (
// // // //                     <Link
// // // //                       to={item.path}
// // // //                       className={`font-medium ${
// // // //                         isActive(item.path)
// // // //                           ? "text-green-400"
// // // //                           : "text-gray-300 hover:text-green-400"
// // // //                       } transition`}
// // // //                       onClick={handleNavLinkClick}
// // // //                     >
// // // //                       {item.title}
// // // //                     </Link>
// // // //                   )}
// // // //                 </div>
// // // //               ))}
// // // //             </div>
// // // //           </div>

// // // //           <div className="hidden md:flex items-center">
// // // //             <Link
// // // //               to="/contact"
// // // //               className="bg-green-600 hover:bg-green-700 text-white text-sm font-semibold rounded-md px-4 py-2 shadow-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 focus:ring-offset-gray-900 transition-all duration-300 hover:scale-105"
// // // //               onClick={handleNavLinkClick}
// // // //             >
// // // //               Get in Touch
// // // //             </Link>
// // // //           </div>

// // // //           <div className="flex items-center md:hidden">
// // // //             <button
// // // //               onClick={() => setMobileMenuOpen((m) => !m)}
// // // //               aria-label="Toggle Navigation Menu"
// // // //               aria-expanded={mobileMenuOpen}
// // // //               className="text-gray-300 p-2 rounded-md hover:bg-green-900/30 focus:outline-none focus:ring-2 focus:ring-green-500"
// // // //             >
// // // //               {mobileMenuOpen ? (
// // // //                 <svg
// // // //                   xmlns="http://www.w3.org/2000/svg"
// // // //                   className="h-6 w-6"
// // // //                   fill="none"
// // // //                   viewBox="0 0 24 24"
// // // //                   stroke="currentColor"
// // // //                 >
// // // //                   <path
// // // //                     strokeLinecap="round"
// // // //                     strokeLinejoin="round"
// // // //                     strokeWidth={2}
// // // //                     d="M6 18L18 6M6 6l12 12"
// // // //                   />
// // // //                 </svg>
// // // //               ) : (
// // // //                 <svg
// // // //                   xmlns="http://www.w3.org/2000/svg"
// // // //                   className="h-6 w-6"
// // // //                   fill="none"
// // // //                   viewBox="0 0 24 24"
// // // //                   stroke="currentColor"
// // // //                 >
// // // //                   <path
// // // //                     strokeLinecap="round"
// // // //                     strokeLinejoin="round"
// // // //                     strokeWidth={2}
// // // //                     d="M4 6h16M4 12h16M4 18h16"
// // // //                   />
// // // //                 </svg>
// // // //               )}
// // // //             </button>
// // // //           </div>
// // // //         </div>
// // // //       </div>

// // // //       {/* Mobile Menu */}
// // // //       <AnimatePresence>
// // // //         {mobileMenuOpen && (
// // // //           <motion.div
// // // //             initial={{ height: 0, opacity: 0 }}
// // // //             animate={{ height: "auto", opacity: 1 }}
// // // //             exit={{ height: 0, opacity: 0 }}
// // // //             transition={{ duration: 0.21 }}
// // // //             className="md:hidden bg-gray-800 border-t border-green-700/30 shadow-lg overflow-hidden"
// // // //           >
// // // //             <div className="flex flex-col px-6 py-4 space-y-4">
// // // //               {NAV_ITEMS.map((item, idx) => (
// // // //                 <div key={idx} className="flex flex-col">
// // // //                   {item.submenu ? (
// // // //                     <>
// // // //                       <button
// // // //                         type="button"
// // // //                         className="flex items-center justify-between w-full font-medium text-gray-300 hover:text-green-400"
// // // //                         onClick={handleServiceToggle}
// // // //                         aria-expanded={servicesOpen}
// // // //                         aria-controls="mobile-submenu"
// // // //                       >
// // // //                         <span>{item.title}</span>
// // // //                         <svg
// // // //                           className={`w-5 h-5 transform transition-transform ${
// // // //                             servicesOpen ? "rotate-180" : "rotate-0"
// // // //                           }`}
// // // //                           fill="none"
// // // //                           stroke="currentColor"
// // // //                           strokeWidth={2}
// // // //                           viewBox="0 0 24 24"
// // // //                           strokeLinecap="round"
// // // //                           strokeLinejoin="round"
// // // //                         >
// // // //                           <path d="M19 9l-7 7-7-7"></path>
// // // //                         </svg>
// // // //                       </button>
// // // //                       <AnimatePresence>
// // // //                         {servicesOpen && (
// // // //                           <motion.div
// // // //                             id="mobile-submenu"
// // // //                             initial={{ opacity: 0, height: 0 }}
// // // //                             animate={{ opacity: 1, height: "auto" }}
// // // //                             exit={{ opacity: 0, height: 0 }}
// // // //                             transition={{ duration: 0.2 }}
// // // //                             className="pl-4 mt-2 flex flex-col space-y-2 overflow-hidden"
// // // //                           >
// // // //                             {item.submenu.map((sub, subIdx) => (
// // // //                               <div key={subIdx}>
// // // //                                 <Link
// // // //                                   to={sub.path}
// // // //                                   className="block text-gray-400 hover:text-green-400"
// // // //                                   onClick={handleNavLinkClick}
// // // //                                 >
// // // //                                   {sub.title}
// // // //                                 </Link>
// // // //                               </div>
// // // //                             ))}
// // // //                           </motion.div>
// // // //                         )}
// // // //                       </AnimatePresence>
// // // //                     </>
// // // //                   ) : (
// // // //                     <Link
// // // //                       to={item.path}
// // // //                       className={`font-medium ${
// // // //                         isActive(item.path)
// // // //                           ? "text-green-400"
// // // //                           : "text-gray-300 hover:text-green-400"
// // // //                       }`}
// // // //                       onClick={handleNavLinkClick}
// // // //                     >
// // // //                       {item.title}
// // // //                     </Link>
// // // //                   )}
// // // //                 </div>
// // // //               ))}

// // // //               {/* Mobile CTA */}
// // // //               <div className="pt-4 border-t border-green-700/30">
// // // //                 <Link
// // // //                   to="/contact"
// // // //                   className="block text-center bg-green-600 rounded-md px-6 py-2 font-semibold text-white hover:bg-green-700 transition"
// // // //                   onClick={handleNavLinkClick}
// // // //                 >
// // // //                   Get in Touch
// // // //                 </Link>
// // // //               </div>
// // // //             </div>
// // // //           </motion.div>
// // // //         )}
// // // //       </AnimatePresence>
// // // //     </nav>
// // // //   );
// // // // };

// // // // // Home Component
// // // // const Home = () => {
// // // //   // Testimonial data
// // // //   const testimonials = [
// // // //     {
// // // //       id: 1,
// // // //       name: "Ahmed Hassan",
// // // //       company: "Djibouti Port Authority",
// // // //       text: "Quadrangle's Solutionss transformed our port operations, increasing efficiency by 40%.",
// // // //       avatar: "👤",
// // // //     },
// // // //     {
// // // //       id: 2,
// // // //       name: "Marie Lambert",
// // // //       company: "Global Logistics Inc.",
// // // //       text: "Their custom software streamlined our cargo management across 12 countries.",
// // // //       avatar: "👤",
// // // //     },
// // // //     {
// // // //       id: 3,
// // // //       name: "John Smith",
// // // //       company: "Maritime Shipping Co.",
// // // //       text: "The digital transformation Quadrangle implemented saved us $2M annually.",
// // // //       avatar: "👤",
// // // //     },
// // // //   ];

// // // //   // Services data
// // // //   const services = [
// // // //     {
// // // //       id: 1,
// // // //       title: "Port Operations Automation",
// // // //       description:
// // // //         "Streamline and automate port management processes for maximum efficiency.",
// // // //       icon: "⚓",
// // // //     },
// // // //     {
// // // //       id: 2,
// // // //       title: "Cargo Management",
// // // //       description:
// // // //         "Optimize cargo handling, tracking, and documentation across your supply chain.",
// // // //       icon: "📦",
// // // //     },
// // // //     {
// // // //       id: 3,
// // // //       title: "Logistics Workflow",
// // // //       description:
// // // //         "Digitally transform your logistics operations with customized Solutionss.",
// // // //       icon: "🚚",
// // // //     },
// // // //     {
// // // //       id: 4,
// // // //       title: "Custom Software Development",
// // // //       description:
// // // //         "Tailor-made Solutionss designed specifically for your business needs.",
// // // //       icon: "💻",
// // // //     },
// // // //   ];

// // // //   // Why Choose Us data
// // // //   const whyChooseUs = [
// // // //     {
// // // //       id: 1,
// // // //       title: "15+ Years Experience",
// // // //       description: "Deep industry knowledge in shipping and logistics",
// // // //       icon: "📅",
// // // //     },
// // // //     {
// // // //       id: 2,
// // // //       title: "Global Client Base",
// // // //       description: "Trusted by companies across multiple continents",
// // // //       icon: "🌎",
// // // //     },
// // // //     {
// // // //       id: 3,
// // // //       title: "Custom Solutionss",
// // // //       description: "Tailored software for your specific business needs",
// // // //       icon: "🛠️",
// // // //     },
// // // //     {
// // // //       id: 4,
// // // //       title: "24/7 Support",
// // // //       description: "Round-the-clock technical assistance and maintenance",
// // // //       icon: "🔧",
// // // //     },
// // // //   ];

// // // //   // Stats data
// // // //   const stats = [
// // // //     {
// // // //       id: 1,
// // // //       value: "15+",
// // // //       label: "Years Experience",
// // // //     },
// // // //     {
// // // //       id: 2,
// // // //       value: "200+",
// // // //       label: "Clients Worldwide",
// // // //     },
// // // //     {
// // // //       id: 3,
// // // //       value: "98%",
// // // //       label: "Client Retention",
// // // //     },
// // // //     {
// // // //       id: 4,
// // // //       value: "24/7",
// // // //       label: "Support Availability",
// // // //     },
// // // //   ];

// // // //   return (
// // // //     <div className="min-h-screen bg-gradient-to-br from-gray-900 to-black text-white overflow-hidden">
// // // //       {/* Animated background elements */}
// // // //       <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0">
// // // //         {[...Array(5)].map((_, i) => (
// // // //           <div
// // // //             key={i}
// // // //             className="absolute rounded-full bg-green-500 opacity-10 animate-pulse"
// // // //             style={{
// // // //               width: `${100 + i * 100}px`,
// // // //               height: `${100 + i * 100}px`,
// // // //               top: `${Math.random() * 100}%`,
// // // //               left: `${Math.random() * 100}%`,
// // // //               animationDuration: `${15 + i * 5}s`,
// // // //               animationDelay: `${i * 2}s`,
// // // //             }}
// // // //           ></div>
// // // //         ))}
// // // //       </div>

// // // //       {/* Navigation */}

// // // //       {/* Hero Section */}
// // // //       <div className="relative pt-32 pb-20 md:pt-40 md:pb-32 z-10">
// // // //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// // // //           <div className="text-center">
// // // //             <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight">
// // // //               <span className="block">Welcome to</span>{" "}
// // // //               <span className="block text-green-400 mt-2 animate-pulse">
// // // //                 Quadrangle Solutions
// // // //               </span>
// // // //             </h1>
// // // //             <p className="mt-6 text-lg md:text-xl max-w-3xl mx-auto text-gray-300 animate-fade-in">
// // // //               Innovating Software for the Shipping, Logistics & Beyond
// // // //             </p>
// // // //             <p className="mt-6 text-base md:text-lg max-w-3xl mx-auto text-gray-400 animate-fade-in delay-300">
// // // //               With over 15 years of domain expertise, Quadrangle Solutions is a
// // // //               trusted name in delivering robust, scalable, and customized
// // // //               software Solutionss, primarily serving the Shipping and Logistics
// // // //               industry.
// // // //             </p>
// // // //             <div className="mt-10 flex justify-center space-x-4 animate-fade-in delay-500">
// // // //               <Link
// // // //                 to="/contact"
// // // //                 className="px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-green-600 hover:bg-green-700 shadow-lg transform transition-all duration-300 hover:scale-105"
// // // //               >
// // // //                 Get in Touch
// // // //               </Link>
// // // //               <Link
// // // //                 to="/services&product"
// // // //                 className="px-6 py-3 border border-green-500 text-base font-medium rounded-md text-green-400 bg-transparent hover:bg-green-900/30 shadow-lg transform transition-all duration-300 hover:scale-105"
// // // //               >
// // // //                 Explore Our Services
// // // //               </Link>
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       </div>

// // // //       {/* Rest of your home page content remains the same */}
// // // //       {/* Stats Section */}
// // // //       <div className="relative py-12 bg-gray-800/30 backdrop-blur-md z-10">
// // // //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// // // //           <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
// // // //             {stats.map((stat) => (
// // // //               <div key={stat.id} className="text-center">
// // // //                 <p className="text-4xl font-extrabold text-green-400">
// // // //                   {stat.value}
// // // //                 </p>
// // // //                 <p className="mt-2 text-sm font-medium text-gray-400 uppercase tracking-wider">
// // // //                   {stat.label}
// // // //                 </p>
// // // //               </div>
// // // //             ))}
// // // //           </div>
// // // //         </div>
// // // //       </div>

// // // //       {/* Why Choose Us Section */}
// // // //       <div className="relative py-16 md:py-24 z-10">
// // // //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// // // //           <div className="text-center mb-16">
// // // //             <h2 className="text-base text-green-400 font-semibold tracking-wide uppercase mb-2">
// // // //               Why Choose Us
// // // //             </h2>
// // // //             <p className="mt-2 text-3xl md:text-4xl font-extrabold tracking-tight text-white sm:text-4xl">
// // // //               The Quadrangle Advantage
// // // //             </p>
// // // //             <p className="mt-4 max-w-2xl text-xl text-gray-400 mx-auto">
// // // //               Discover why industry leaders trust us for their software
// // // //               Solutionss
// // // //             </p>
// // // //           </div>

// // // //           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
// // // //             {whyChooseUs.map((item) => (
// // // //               <div
// // // //                 key={item.id}
// // // //                 className="bg-gradient-to-b from-gray-800 to-gray-900 p-6 rounded-xl border border-gray-700 hover:border-green-400 transition-all duration-500 hover:-translate-y-2 transform group text-center"
// // // //               >
// // // //                 <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-green-900/30 text-2xl text-green-400 mb-4 group-hover:scale-110 transition-transform duration-300">
// // // //                   {item.icon}
// // // //                 </div>
// // // //                 <h3 className="text-lg font-medium text-white mb-2">
// // // //                   {item.title}
// // // //                 </h3>
// // // //                 <p className="text-gray-400 text-sm">{item.description}</p>
// // // //               </div>
// // // //             ))}
// // // //           </div>
// // // //         </div>
// // // //       </div>

// // // //       {/* Services Section */}
// // // //       <div className="relative py-16 md:py-24 z-10">
// // // //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// // // //           <div className="text-center mb-16">
// // // //             <h2 className="text-base text-green-400 font-semibold tracking-wide uppercase mb-2">
// // // //               Our Services
// // // //             </h2>
// // // //             <p className="mt-2 text-3xl md:text-4xl font-extrabold tracking-tight text-white sm:text-4xl">
// // // //               Solutionss for Your Business Needs
// // // //             </p>
// // // //             <p className="mt-4 max-w-2xl text-xl text-gray-400 mx-auto">
// // // //               Custom software Solutionss designed to optimize your operations
// // // //             </p>
// // // //           </div>

// // // //           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
// // // //             {services.map((service) => (
// // // //               <div
// // // //                 key={service.id}
// // // //                 className="bg-gradient-to-b from-gray-800 to-gray-900 p-8 rounded-xl border border-gray-700 hover:border-green-400 transition-all duration-500 hover:-translate-y-2 transform group"
// // // //               >
// // // //                 <div className="flex items-start">
// // // //                   <div className="text-3xl text-green-400 mr-4 group-hover:scale-110 transition-transform duration-300">
// // // //                     {service.icon}
// // // //                   </div>
// // // //                   <div>
// // // //                     <h3 className="text-xl font-medium text-white mb-2">
// // // //                       {service.title}
// // // //                     </h3>
// // // //                     <p className="text-gray-400">{service.description}</p>
// // // //                     <Link
// // // //                       to="/services&product"
// // // //                       className="mt-4 text-green-400 hover:text-green-300 flex items-center transition-colors duration-300"
// // // //                     >
// // // //                       Learn more
// // // //                       <svg
// // // //                         className="w-4 h-4 ml-1"
// // // //                         fill="none"
// // // //                         stroke="currentColor"
// // // //                         viewBox="0 0 24 24"
// // // //                         xmlns="http://www.w3.org/2000/svg"
// // // //                       >
// // // //                         <path
// // // //                           strokeLinecap="round"
// // // //                           strokeLinejoin="round"
// // // //                           strokeWidth="2"
// // // //                           d="M14 5l7 7m0 0l-7 7m7-7H3"
// // // //                         ></path>
// // // //                       </svg>
// // // //                     </Link>
// // // //                   </div>
// // // //                 </div>
// // // //               </div>
// // // //             ))}
// // // //           </div>

// // // //           <div className="mt-12 text-center">
// // // //             <Link
// // // //               to="/services&product"
// // // //               className="px-8 py-3 border border-green-500 text-base font-medium rounded-md text-green-400 bg-transparent hover:bg-green-900/30 shadow-lg transform transition-all duration-300 hover:scale-105"
// // // //             >
// // // //               View All Services
// // // //             </Link>
// // // //           </div>
// // // //         </div>
// // // //       </div>

// // // //       {/* How It Works Section */}
// // // //       <div className="relative py-16 md:py-24 z-10">
// // // //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// // // //           <div className="text-center mb-16">
// // // //             <h2 className="text-base text-green-400 font-semibold tracking-wide uppercase mb-2">
// // // //               Our Process
// // // //             </h2>
// // // //             <p className="mt-2 text-3xl md:text-4xl font-extrabold tracking-tight text-white sm:text-4xl">
// // // //               How We Deliver Excellence
// // // //             </p>
// // // //           </div>

// // // //           <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative">
// // // //             {/* Connecting line */}
// // // //             <div className="hidden md:block absolute top-12 left-1/4 right-1/4 h-0.5 bg-green-400 z-0"></div>

// // // //             {[
// // // //               {
// // // //                 step: "01",
// // // //                 title: "Consultation",
// // // //                 desc: "We analyze your business needs and challenges",
// // // //               },
// // // //               {
// // // //                 step: "02",
// // // //                 title: "Planning",
// // // //                 desc: "Our team designs a tailored Solutions strategy",
// // // //               },
// // // //               {
// // // //                 step: "03",
// // // //                 title: "Development",
// // // //                 desc: "We build robust, scalable software Solutionss",
// // // //               },
// // // //               {
// // // //                 step: "04",
// // // //                 title: "Support",
// // // //                 desc: "Ongoing maintenance and optimization services",
// // // //               },
// // // //             ].map((item, index) => (
// // // //               <div
// // // //                 key={index}
// // // //                 className="flex flex-col items-center text-center relative z-10"
// // // //               >
// // // //                 <div className="flex items-center justify-center h-16 w-16 rounded-full bg-green-600 text-white font-bold text-lg mb-4">
// // // //                   {item.step}
// // // //                 </div>
// // // //                 <h3 className="text-lg font-medium text-white mb-2">
// // // //                   {item.title}
// // // //                 </h3>
// // // //                 <p className="text-gray-400 text-sm">{item.desc}</p>
// // // //               </div>
// // // //             ))}
// // // //           </div>
// // // //         </div>
// // // //       </div>

// // // //       {/* Testimonials */}
// // // //       <div className="relative py-16 md:py-24 z-10">
// // // //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// // // //           <div className="text-center mb-16">
// // // //             <h2 className="text-base text-green-400 font-semibold tracking-wide uppercase mb-2">
// // // //               Testimonials
// // // //             </h2>
// // // //             <p className="mt-2 text-3xl md:text-4xl font-extrabold tracking-tight text-white sm:text-4xl">
// // // //               What Our Clients Say
// // // //             </p>
// // // //           </div>

// // // //           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
// // // //             {testimonials.map((testimonial) => (
// // // //               <div
// // // //                 key={testimonial.id}
// // // //                 className="bg-gradient-to-b from-gray-800 to-gray-900 p-8 rounded-xl border border-gray-700 hover:border-green-400 transition-all duration-500 hover:-translate-y-2 transform"
// // // //               >
// // // //                 <div className="flex items-center mb-4">
// // // //                   <div className="text-2xl mr-4">{testimonial.avatar}</div>
// // // //                   <div>
// // // //                     <h4 className="text-lg font-bold text-white">
// // // //                       {testimonial.name}
// // // //                     </h4>
// // // //                     <p className="text-green-400 text-sm">
// // // //                       {testimonial.company}
// // // //                     </p>
// // // //                   </div>
// // // //                 </div>
// // // //                 <p className="text-gray-300 italic">"{testimonial.text}"</p>
// // // //               </div>
// // // //             ))}
// // // //           </div>
// // // //         </div>
// // // //       </div>

// // // //       {/* CTA Section */}
// // // //       <div className="relative py-16 md:py-24 z-10">
// // // //         <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center bg-gradient-to-r from-green-900/30 to-gray-900/50 backdrop-blur-md p-12 rounded-2xl border border-gray-700">
// // // //           <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
// // // //             Ready to Transform Your Business?
// // // //           </h2>
// // // //           <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
// // // //             Get in touch with us today to discuss how our Solutionss can help
// // // //             streamline your operations and drive growth.
// // // //           </p>
// // // //           <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
// // // //             <Link
// // // //               to="/contact"
// // // //               className="px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-green-600 hover:bg-green-700 shadow-lg transform transition-all duration-300 hover:scale-105"
// // // //             >
// // // //               Contact Us Now
// // // //             </Link>
// // // //             <Link
// // // //               to="/case-studies"
// // // //               className="px-8 py-3 border border-green-500 text-base font-medium rounded-md text-green-400 bg-transparent hover:bg-green-900/30 shadow-lg transform transition-all duration-300 hover:scale-105"
// // // //             >
// // // //               View Case Studies
// // // //             </Link>
// // // //           </div>
// // // //         </div>
// // // //       </div>

// // // //       {/* Custom CSS for animations */}
// // // //       <style jsx>{`
// // // //         @keyframes fadeIn {
// // // //           from {
// // // //             opacity: 0;
// // // //             transform: translateY(20px);
// // // //           }
// // // //           to {
// // // //             opacity: 1;
// // // //             transform: translateY(0);
// // // //           }
// // // //         }
// // // //         .animate-fade-in {
// // // //           opacity: 0;
// // // //           animation: fadeIn 1s ease-out forwards;
// // // //         }
// // // //         .delay-300 {
// // // //           animation-delay: 0.3s;
// // // //         }
// // // //         .delay-500 {
// // // //           animation-delay: 0.5s;
// // // //         }
// // // //       `}</style>
// // // //     </div>
// // // //   );
// // // // };

// // // // export default Home;

// // // import React from "react";
// // // import { Link } from "react-router-dom";
// // // import { motion } from "framer-motion";
// // // import Hero from "../components/hero";
// // // import AboutUs from "../components/Aboutus";

// // // // Enhanced Home Component
// // // const Home = () => {
// // //   // Stats
// // //   const stats = [
// // //     { id: 1, value: "15+", label: "Years Experience" },
// // //     { id: 2, value: "200+", label: "Global Clients" },
// // //     { id: 3, value: "98%", label: "Client Retention" },
// // //     { id: 4, value: "24/7", label: "Support Availability" },
// // //   ];

// // //   // Why Choose Us
// // //   const whyChooseUs = [
// // //     {
// // //       id: 1,
// // //       title: "15+ Years Experience",
// // //       desc: "Deep industry knowledge in shipping & logistics",
// // //       icon: "📅",
// // //     },
// // //     {
// // //       id: 2,
// // //       title: "Global Client Base",
// // //       desc: "Trusted across multiple continents",
// // //       icon: "🌎",
// // //     },
// // //     {
// // //       id: 3,
// // //       title: "Custom Solutionss",
// // //       desc: "Tailored software for your business",
// // //       icon: "🛠️",
// // //     },
// // //     {
// // //       id: 4,
// // //       title: "24/7 Support",
// // //       desc: "Round-the-clock assistance",
// // //       icon: "🔧",
// // //     },
// // //   ];

// // //   // Services
// // //   const services = [
// // //     {
// // //       id: 1,
// // //       title: "Port Automation",
// // //       desc: "Streamline & automate port processes.",
// // //       icon: "⚓",
// // //     },
// // //     {
// // //       id: 2,
// // //       title: "Cargo Management",
// // //       desc: "Optimize cargo handling & tracking.",
// // //       icon: "📦",
// // //     },
// // //     {
// // //       id: 3,
// // //       title: "Logistics Workflow",
// // //       desc: "Digitally transform logistics ops.",
// // //       icon: "🚚",
// // //     },
// // //     {
// // //       id: 4,
// // //       title: "Custom Development",
// // //       desc: "Tailor-made software Solutionss.",
// // //       icon: "💻",
// // //     },
// // //   ];

// // //   // Testimonials
// // //   const testimonials = [
// // //     {
// // //       id: 1,
// // //       name: "Ahmed Hassan",
// // //       company: "Djibouti Port Authority",
// // //       text: "Quadrangle's Solutionss transformed our port operations, increasing efficiency by 40%.",
// // //     },
// // //     {
// // //       id: 2,
// // //       name: "Marie Lambert",
// // //       company: "Global Logistics Inc.",
// // //       text: "Their software streamlined cargo management across 12 countries.",
// // //     },
// // //     {
// // //       id: 3,
// // //       name: "John Smith",
// // //       company: "Maritime Shipping Co.",
// // //       text: "The digital transformation saved us $2M annually.",
// // //     },
// // //   ];

// // //   return (
// // //     <div className="bg-gradient-to-b from-black via-gray-900 to-black text-white overflow-hidden">
// // //       {/* ✅ Hero stays untouched above this */}
// // //       <Hero />
// // //       <AboutUs />

// // //       {/* Stats Section */}
// // //       <section className="py-16 bg-gradient-to-r from-gray-900/70 to-black/70 backdrop-blur-md">
// // //         <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
// // //           {stats.map((s) => (
// // //             <motion.div
// // //               key={s.id}
// // //               whileHover={{ scale: 1.1 }}
// // //               className="p-6 rounded-xl bg-gray-800/40 border border-gray-700 shadow-lg"
// // //             >
// // //               <p className="text-4xl font-extrabold text-green-400">
// // //                 {s.value}
// // //               </p>
// // //               <p className="mt-2 text-gray-400">{s.label}</p>
// // //             </motion.div>
// // //           ))}
// // //         </div>
// // //       </section>

// // //       {/* Why Choose Us */}
// // //       <section className="py-20">
// // //         <div className="max-w-6xl mx-auto text-center">
// // //           <h2 className="text-green-400 font-semibold uppercase">
// // //             Why Choose Us
// // //           </h2>
// // //           <p className="text-4xl font-bold mt-2 mb-12">
// // //             The Quadrangle Advantage
// // //           </p>
// // //           <div className="grid md:grid-cols-4 gap-8">
// // //             {whyChooseUs.map((w) => (
// // //               <motion.div
// // //                 key={w.id}
// // //                 whileHover={{ y: -8 }}
// // //                 className="p-8 rounded-xl bg-gray-800/50 border border-gray-700 shadow-md hover:border-green-400 transition"
// // //               >
// // //                 <div className="text-4xl mb-4">{w.icon}</div>
// // //                 <h3 className="text-lg font-bold">{w.title}</h3>
// // //                 <p className="text-gray-400 text-sm mt-2">{w.desc}</p>
// // //               </motion.div>
// // //             ))}
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* Services Section */}
// // //       <section className="py-20 bg-gradient-to-br from-green-900/20 to-transparent">
// // //         <div className="max-w-6xl mx-auto text-center">
// // //           <h2 className="text-green-400 uppercase font-semibold">
// // //             Our Services
// // //           </h2>
// // //           <p className="text-4xl font-bold mt-2 mb-12">
// // //             Solutionss for Your Business
// // //           </p>
// // //           <div className="grid md:grid-cols-2 gap-10">
// // //             {services.map((s) => (
// // //               <motion.div
// // //                 key={s.id}
// // //                 whileHover={{ scale: 1.03 }}
// // //                 className="p-8 rounded-xl bg-gray-800/50 border border-gray-700 text-left shadow-md hover:border-green-400 transition"
// // //               >
// // //                 <div className="text-3xl text-green-400">{s.icon}</div>
// // //                 <h3 className="text-xl font-bold mt-3">{s.title}</h3>
// // //                 <p className="text-gray-400 mt-2">{s.desc}</p>
// // //                 <Link
// // //                   to="/services&product"
// // //                   className="inline-flex items-center text-green-400 mt-4 hover:underline"
// // //                 >
// // //                   Learn more →
// // //                 </Link>
// // //               </motion.div>
// // //             ))}
// // //           </div>
// // //           <div className="mt-12">
// // //             <Link
// // //               to="/services&product"
// // //               className="px-8 py-3 rounded-md border border-green-400 text-green-400 hover:bg-green-900/30 transition"
// // //             >
// // //               View All Services
// // //             </Link>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* Testimonials */}
// // //       <section className="py-20 bg-gray-900/40">
// // //         <div className="max-w-6xl mx-auto text-center">
// // //           <h2 className="text-green-400 uppercase font-semibold">
// // //             Testimonials
// // //           </h2>
// // //           <p className="text-4xl font-bold mt-2 mb-12">What Clients Say</p>
// // //           <div className="grid md:grid-cols-3 gap-8">
// // //             {testimonials.map((t) => (
// // //               <motion.div
// // //                 key={t.id}
// // //                 whileHover={{ y: -8 }}
// // //                 className="p-8 rounded-xl bg-gray-800/50 border border-gray-700 shadow-lg hover:border-green-400 transition"
// // //               >
// // //                 <p className="italic text-gray-300">"{t.text}"</p>
// // //                 <div className="mt-4 text-green-400 font-semibold">
// // //                   {t.name}
// // //                 </div>
// // //                 <p className="text-gray-400 text-sm">{t.company}</p>
// // //               </motion.div>
// // //             ))}
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* CTA */}
// // //       <section className="py-20">
// // //         <div className="max-w-4xl mx-auto text-center bg-gradient-to-r from-green-800/30 to-gray-900/50 p-12 rounded-2xl border border-gray-700 shadow-xl">
// // //           <h2 className="text-3xl md:text-4xl font-bold mb-4">
// // //             Ready to Transform Your Business?
// // //           </h2>
// // //           <p className="text-lg text-gray-300 mb-8">
// // //             Let’s discuss how Quadrangle can help you achieve growth &
// // //             efficiency.
// // //           </p>
// // //           <div className="flex flex-col sm:flex-row gap-4 justify-center">
// // //             <Link
// // //               to="/contact"
// // //               className="px-8 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 transition"
// // //             >
// // //               Contact Us
// // //             </Link>
// // //             <Link
// // //               to="/case-studies"
// // //               className="px-8 py-3 border border-green-400 text-green-400 rounded-md hover:bg-green-900/30 transition"
// // //             >
// // //               View Case Studies
// // //             </Link>
// // //           </div>
// // //         </div>
// // //       </section>
// // //     </div>
// // //   );
// // // };

// // // export default Home;

// // // import React from "react";
// // // import { Link } from "react-router-dom";
// // // import { motion } from "framer-motion";
// // // import Hero from "../components/hero";
// // // import AboutUs from "../components/Aboutus";

// // // // Enhanced Home Component with different background effect
// // // const Home = () => {
// // //   // Stats
// // //   const stats = [
// // //     { id: 1, value: "15+", label: "Years Experience" },
// // //     { id: 2, value: "200+", label: "Global Clients" },
// // //     { id: 3, value: "98%", label: "Client Retention" },
// // //     { id: 4, value: "24/7", label: "Support Availability" },
// // //   ];

// // //   // Why Choose Us
// // //   const whyChooseUs = [
// // //     {
// // //       id: 1,
// // //       title: "15+ Years Experience",
// // //       desc: "Deep industry knowledge in shipping & logistics",
// // //       icon: "📅",
// // //     },
// // //     {
// // //       id: 2,
// // //       title: "Global Client Base",
// // //       desc: "Trusted across multiple continents",
// // //       icon: "🌎",
// // //     },
// // //     {
// // //       id: 3,
// // //       title: "Custom Solutionss",
// // //       desc: "Tailored software for your business",
// // //       icon: "🛠️",
// // //     },
// // //     {
// // //       id: 4,
// // //       title: "24/7 Support",
// // //       desc: "Round-the-clock assistance",
// // //       icon: "🔧",
// // //     },
// // //   ];

// // //   // Services
// // //   const services = [
// // //     {
// // //       id: 1,
// // //       title: "Port Automation",
// // //       desc: "Streamline & automate port processes.",
// // //       icon: "⚓",
// // //     },
// // //     {
// // //       id: 2,
// // //       title: "Cargo Management",
// // //       desc: "Optimize cargo handling & tracking.",
// // //       icon: "📦",
// // //     },
// // //     {
// // //       id: 3,
// // //       title: "Logistics Workflow",
// // //       desc: "Digitally transform logistics ops.",
// // //       icon: "🚚",
// // //     },
// // //     {
// // //       id: 4,
// // //       title: "Custom Development",
// // //       desc: "Tailor-made software Solutionss.",
// // //       icon: "💻",
// // //     },
// // //   ];

// // //   // Testimonials
// // //   const testimonials = [
// // //     {
// // //       id: 1,
// // //       name: "Ahmed Hassan",
// // //       company: "Djibouti Port Authority",
// // //       text: "Quadrangle's Solutionss transformed our port operations, increasing efficiency by 40%.",
// // //     },
// // //     {
// // //       id: 2,
// // //       name: "Marie Lambert",
// // //       company: "Global Logistics Inc.",
// // //       text: "Their software streamlined cargo management across 12 countries.",
// // //     },
// // //     {
// // //       id: 3,
// // //       name: "John Smith",
// // //       company: "Maritime Shipping Co.",
// // //       text: "The digital transformation saved us $2M annually.",
// // //     },
// // //   ];

// // //   return (
// // //     <div className="text-white overflow-hidden relative">
// // //       {/* New background effect with geometric patterns */}
// // //       <div className="absolute inset-0 z-0 overflow-hidden">
// // //         {/* Geometric grid pattern */}
// // //         <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]"></div>

// // //         {/* Gradient overlays */}
// // //         <div className="absolute top-0 left-0 w-full h-1/3 bg-gradient-to-b from-emerald-900/10 to-transparent"></div>
// // //         <div className="absolute bottom-0 left-0 w-full h-1/3 bg-gradient-to-t from-blue-900/10 to-transparent"></div>

// // //         {/* Animated floating shapes */}
// // //         {[...Array(8)].map((_, i) => (
// // //           <div
// // //             key={i}
// // //             className="absolute rounded-full bg-emerald-500/10 animate-float"
// // //             style={{
// // //               width: `${40 + i * 20}px`,
// // //               height: `${40 + i * 20}px`,
// // //               top: `${10 + i * 10}%`,
// // //               left: `${Math.random() * 100}%`,
// // //               animationDuration: `${15 + i * 5}s`,
// // //               animationDelay: `${i * 2}s`,
// // //             }}
// // //           ></div>
// // //         ))}

// // //         {/* Light effects */}
// // //         <div className="absolute top-1/4 -left-20 w-72 h-72 bg-emerald-400/10 rounded-full filter blur-3xl"></div>
// // //         <div className="absolute bottom-1/4 -right-20 w-72 h-72 bg-blue-400/10 rounded-full filter blur-3xl"></div>
// // //       </div>

// // //       {/* Content with backdrop blur for better readability */}
// // //       <div className="relative z-10">
// // //         <Hero />
// // //         <AboutUs />

// // //         {/* Stats Section */}
// // //         <section className="py-16 bg-gradient-to-r from-gray-900/70 to-black/70 backdrop-blur-md">
// // //           <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
// // //             {stats.map((s) => (
// // //               <motion.div
// // //                 key={s.id}
// // //                 whileHover={{ scale: 1.1 }}
// // //                 className="p-6 rounded-xl bg-gray-800/40 border border-gray-700 shadow-lg"
// // //               >
// // //                 <p className="text-4xl font-extrabold text-green-400">
// // //                   {s.value}
// // //                 </p>
// // //                 <p className="mt-2 text-gray-400">{s.label}</p>
// // //               </motion.div>
// // //             ))}
// // //           </div>
// // //         </section>

// // //         {/* Why Choose Us */}
// // //         <section className="py-20">
// // //           <div className="max-w-6xl mx-auto text-center">
// // //             <h2 className="text-green-400 font-semibold uppercase">
// // //               Why Choose Us
// // //             </h2>
// // //             <p className="text-4xl font-bold mt-2 mb-12">
// // //               The Quadrangle Advantage
// // //             </p>
// // //             <div className="grid md:grid-cols-4 gap-8">
// // //               {whyChooseUs.map((w) => (
// // //                 <motion.div
// // //                   key={w.id}
// // //                   whileHover={{ y: -8 }}
// // //                   className="p-8 rounded-xl bg-gray-800/50 border border-gray-700 shadow-md hover:border-green-400 transition backdrop-blur-sm"
// // //                 >
// // //                   <div className="text-4xl mb-4">{w.icon}</div>
// // //                   <h3 className="text-lg font-bold">{w.title}</h3>
// // //                   <p className="text-gray-400 text-sm mt-2">{w.desc}</p>
// // //                 </motion.div>
// // //               ))}
// // //             </div>
// // //           </div>
// // //         </section>

// // //         {/* Services Section */}
// // //         <section className="py-20 bg-gradient-to-br from-green-900/20 to-transparent">
// // //           <div className="max-w-6xl mx-auto text-center">
// // //             <h2 className="text-green-400 uppercase font-semibold">
// // //               Our Services
// // //             </h2>
// // //             <p className="text-4xl font-bold mt-2 mb-12">
// // //               Solutionss for Your Business
// // //             </p>
// // //             <div className="grid md:grid-cols-2 gap-10">
// // //               {services.map((s) => (
// // //                 <motion.div
// // //                   key={s.id}
// // //                   whileHover={{ scale: 1.03 }}
// // //                   className="p-8 rounded-xl bg-gray-800/50 border border-gray-700 text-left shadow-md hover:border-green-400 transition backdrop-blur-sm"
// // //                 >
// // //                   <div className="text-3xl text-green-400">{s.icon}</div>
// // //                   <h3 className="text-xl font-bold mt-3">{s.title}</h3>
// // //                   <p className="text-gray-400 mt-2">{s.desc}</p>
// // //                   <Link
// // //                     to="/services&product"
// // //                     className="inline-flex items-center text-green-400 mt-4 hover:underline"
// // //                   >
// // //                     Learn more →
// // //                   </Link>
// // //                 </motion.div>
// // //               ))}
// // //             </div>
// // //             <div className="mt-12">
// // //               <Link
// // //                 to="/services&product"
// // //                 className="px-8 py-3 rounded-md border border-green-400 text-green-400 hover:bg-green-900/30 transition"
// // //               >
// // //                 View All Services
// // //               </Link>
// // //             </div>
// // //           </div>
// // //         </section>

// // //         {/* Testimonials */}
// // //         <section className="py-20 bg-gray-900/40">
// // //           <div className="max-w-6xl mx-auto text-center">
// // //             <h2 className="text-green-400 uppercase font-semibold">
// // //               Testimonials
// // //             </h2>
// // //             <p className="text-4xl font-bold mt-2 mb-12">What Clients Say</p>
// // //             <div className="grid md:grid-cols-3 gap-8">
// // //               {testimonials.map((t) => (
// // //                 <motion.div
// // //                   key={t.id}
// // //                   whileHover={{ y: -8 }}
// // //                   className="p-8 rounded-xl bg-gray-800/50 border border-gray-700 shadow-lg hover:border-green-400 transition backdrop-blur-sm"
// // //                 >
// // //                   <p className="italic text-gray-300">"{t.text}"</p>
// // //                   <div className="mt-4 text-green-400 font-semibold">
// // //                     {t.name}
// // //                   </div>
// // //                   <p className="text-gray-400 text-sm">{t.company}</p>
// // //                 </motion.div>
// // //               ))}
// // //             </div>
// // //           </div>
// // //         </section>

// // //         {/* CTA */}
// // //         <section className="py-20">
// // //           <div className="max-w-4xl mx-auto text-center bg-gradient-to-r from-green-800/30 to-gray-900/50 p-12 rounded-2xl border border-gray-700 shadow-xl backdrop-blur-sm">
// // //             <h2 className="text-3xl md:text-4xl font-bold mb-4">
// // //               Ready to Transform Your Business?
// // //             </h2>
// // //             <p className="text-lg text-gray-300 mb-8">
// // //               Let's discuss how Quadrangle can help you achieve growth &
// // //               efficiency.
// // //             </p>
// // //             <div className="flex flex-col sm:flex-row gap-4 justify-center">
// // //               <Link
// // //                 to="/contact"
// // //                 className="px-8 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 transition"
// // //               >
// // //                 Contact Us
// // //               </Link>
// // //               <Link
// // //                 to="/case-studies"
// // //                 className="px-8 py-3 border border-green-400 text-green-400 rounded-md hover:bg-green-900/30 transition"
// // //               >
// // //                 View Case Studies
// // //               </Link>
// // //             </div>
// // //           </div>
// // //         </section>
// // //       </div>

// // //       {/* Custom CSS for animations */}
// // //       <style jsx>{`
// // //         @keyframes float {
// // //           0%,
// // //           100% {
// // //             transform: translateY(0) rotate(0deg);
// // //           }
// // //           50% {
// // //             transform: translateY(-20px) rotate(5deg);
// // //           }
// // //         }
// // //         .animate-float {
// // //           animation: float 8s ease-in-out infinite;
// // //         }
// // //       `}</style>
// // //     </div>
// // //   );
// // // };

// // // export default Home;

// // import React from "react";
// // import { Link } from "react-router-dom";
// // import { motion } from "framer-motion";
// // import Hero from "../components/hero";
// // import AboutUs from "../components/Aboutus";

// // // Enhanced Home Component with updated About section
// // const Home = () => {
// //   // Why Choose Us
// //   const whyChooseUs = [
// //     {
// //       id: 1,
// //       title: "15+ Years Experience",
// //       desc: "Deep industry knowledge in shipping & logistics",
// //       icon: "📅",
// //     },
// //     {
// //       id: 2,
// //       title: "Global Client Base",
// //       desc: "Trusted across multiple continents",
// //       icon: "🌎",
// //     },
// //     {
// //       id: 3,
// //       title: "Custom Solutions",
// //       desc: "Tailored software for your business",
// //       icon: "🛠️",
// //     },
// //     {
// //       id: 4,
// //       title: "24/7 Support",
// //       desc: "Round-the-clock assistance",
// //       icon: "🔧",
// //     },
// //   ];

// //   // Services
// //   const services = [
// //     {
// //       id: 1,
// //       title: "Port Automation",
// //       desc: "Streamline & automate port processes.",
// //       icon: "⚓",
// //     },
// //     {
// //       id: 2,
// //       title: "Cargo Management",
// //       desc: "Optimize cargo handling & tracking.",
// //       icon: "📦",
// //     },
// //     {
// //       id: 3,
// //       title: "Logistics Workflow",
// //       desc: "Digitally transform logistics ops.",
// //       icon: "🚚",
// //     },
// //     {
// //       id: 4,
// //       title: "Custom Development",
// //       desc: "Tailor-made software solutions.",
// //       icon: "💻",
// //     },
// //   ];

// //   // Testimonials
// //   const testimonials = [
// //     {
// //       id: 1,
// //       name: "Ahmed Hassan",
// //       company: "",
// //       text: "Quadrangle's solutions transformed our port operations, increasing efficiency by 40%.",
// //     },
// //     {
// //       id: 2,
// //       name: "Marie Lambert",
// //       company: "Global Logistics Inc.",
// //       text: "Their software streamlined cargo management across  countries.",
// //     },
// //     {
// //       id: 3,
// //       name: "John Smith",
// //       company: "",
// //       text: "The digital transformation saved us  annually.",
// //     },
// //   ];

// //   // Core Values
// //   const coreValues = [
// //     {
// //       id: 1,
// //       title: "AI Innovation",
// //       desc: "Harnessing the power of artificial intelligence to deliver smarter, future-ready solutions.",
// //     },
// //     {
// //       id: 2,
// //       title: "Customer Success",
// //       desc: "Putting clients at the center of everything we do and enabling their growth through technology.",
// //     },
// //     {
// //       id: 3,
// //       title: "Integrity",
// //       desc: "Building trust through transparency, accountability, and ethical practices.",
// //     },
// //     {
// //       id: 4,
// //       title: "Excellence",
// //       desc: "Striving for the highest quality in every solution, service, and interaction.",
// //     },
// //     {
// //       id: 5,
// //       title: "Collaboration",
// //       desc: "Working as partners with our clients, employees, and stakeholders to achieve shared success.",
// //     },
// //     {
// //       id: 6,
// //       title: "Data-Driven Decisions",
// //       desc: "Leveraging data and analytics to create intelligent, result-oriented solutions.",
// //     },
// //     // {
// //     //   id: 7,
// //     //   title: "Adaptability",
// //     //   desc: "Responding proactively to evolving industry needs with flexible and scalable innovations.",
// //     // },
// //   ];

// //   return (
// //     <div className="text-white overflow-hidden relative">
// //       {/* Background */}
// //       <div className="absolute inset-0 z-0 overflow-hidden">
// //         {/* Grid */}
// //         <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]"></div>
// //         <div className="absolute top-0 left-0 w-full h-1/3 bg-gradient-to-b from-emerald-900/10 to-transparent"></div>
// //         <div className="absolute bottom-0 left-0 w-full h-1/3 bg-gradient-to-t from-blue-900/10 to-transparent"></div>
// //         {[...Array(8)].map((_, i) => (
// //           <div
// //             key={i}
// //             className="absolute rounded-full bg-emerald-500/10 animate-float"
// //             style={{
// //               width: `${40 + i * 20}px`,
// //               height: `${40 + i * 20}px`,
// //               top: `${10 + i * 10}%`,
// //               left: `${Math.random() * 100}%`,
// //               animationDuration: `${15 + i * 5}s`,
// //               animationDelay: `${i * 2}s`,
// //             }}
// //           ></div>
// //         ))}
// //       </div>

// //       {/* Content */}
// //       <div className="relative z-10">
// //         <Hero />
// //         <AboutUs />

// //         {/* Vision & Mission */}
// //         <section className="py-20">
// //           <div className="max-w-5xl mx-auto text-center space-y-12">
// //             <motion.div
// //               whileHover={{ scale: 1.02 }}
// //               className="bg-gray-800/60 p-10 rounded-2xl border border-gray-700 shadow-lg backdrop-blur-sm"
// //             >
// //               <h2 className="text-green-400 uppercase font-semibold">
// //                 Vision Statement
// //               </h2>
// //               <p className="mt-4 text-xl text-gray-100 leading-relaxed">
// //                 To be a globally trusted technology partner, empowering
// //                 businesses in shipping, logistics, and beyond with AI-driven,
// //                 scalable, and future-ready software solutions that drive
// //                 efficiency, reliability, and growth.
// //               </p>
// //             </motion.div>

// //             <motion.div
// //               whileHover={{ scale: 1.02 }}
// //               className="bg-gray-800/60 p-10 rounded-2xl border border-gray-700 shadow-lg backdrop-blur-sm"
// //             >
// //               <h2 className="text-green-400 uppercase font-semibold">
// //                 Mission Statement
// //               </h2>
// //               <p className="mt-4 text-xl text-gray-100 leading-relaxed">
// //                 Our mission is to bridge the gap between industry challenges and
// //                 technology by delivering AI-powered IT solutions that simplify
// //                 complex operations, enhance productivity, and create long-term
// //                 value for our clients. Guided by innovation, integrity, and
// //                 customer-centricity, we strive to transform logistics and allied
// //                 industries into smarter, more connected ecosystems.
// //               </p>
// //             </motion.div>
// //           </div>
// //         </section>

// //         {/* Core Values */}
// //         <section className="py-20 bg-gray-900/60">
// //           <div className="max-w-6xl mx-auto text-center">
// //             <h2 className="text-green-400 uppercase font-semibold mb-12">
// //               Core Values
// //             </h2>
// //             <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
// //               {coreValues.map((value) => (
// //                 <motion.div
// //                   key={value.id}
// //                   whileHover={{ y: -6 }}
// //                   className="p-8 bg-gray-800/60 rounded-xl border border-gray-700 shadow-md hover:border-green-400 transition backdrop-blur-sm"
// //                 >
// //                   <h3 className="text-xl font-bold text-white">
// //                     {value.title}
// //                   </h3>
// //                   <p className="text-gray-100 mt-3 text-base">{value.desc}</p>
// //                 </motion.div>
// //               ))}
// //             </div>
// //           </div>
// //         </section>

// //         {/* Why Choose Us */}
// //         <section className="py-20">
// //           <div className="max-w-6xl mx-auto text-center">
// //             <h2 className="text-green-400 font-semibold uppercase">
// //               Why Choose Us
// //             </h2>
// //             <p className="text-4xl font-bold mt-2 mb-12 text-green-400">
// //               The Quadrangle Advantage
// //             </p>
// //             <div className="grid md:grid-cols-4 gap-8">
// //               {whyChooseUs.map((w) => (
// //                 <motion.div
// //                   key={w.id}
// //                   whileHover={{ y: -8 }}
// //                   className="p-8 rounded-xl bg-gray-800/60 border border-gray-700 shadow-md hover:border-green-400 transition backdrop-blur-sm"
// //                 >
// //                   <div className="text-4xl mb-4">{w.icon}</div>
// //                   <h3 className="text-lg font-bold text-white">{w.title}</h3>
// //                   <p className="text-gray-100 text-sm mt-2">{w.desc}</p>
// //                 </motion.div>
// //               ))}
// //             </div>
// //           </div>
// //         </section>

// //         {/* Services */}
// //         <section className="py-20 bg-gradient-to-br from-green-900/20 to-transparent">
// //           <div className="max-w-6xl mx-auto text-center">
// //             <h2 className="text-green-400 uppercase font-semibold">
// //               Our Services
// //             </h2>
// //             <p className="text-4xl font-bold mt-2 mb-12 text-white">
// //               Solutions for Your Business
// //             </p>
// //             <div className="grid md:grid-cols-2 gap-10">
// //               {services.map((s) => (
// //                 <motion.div
// //                   key={s.id}
// //                   whileHover={{ scale: 1.03 }}
// //                   className="p-8 rounded-xl bg-gray-800/60 border border-gray-700 text-left shadow-md hover:border-green-400 transition backdrop-blur-sm"
// //                 >
// //                   <div className="text-3xl text-green-400">{s.icon}</div>
// //                   <h3 className="text-xl font-bold mt-3 text-white">
// //                     {s.title}
// //                   </h3>
// //                   <p className="text-gray-100 mt-2">{s.desc}</p>
// //                   <Link
// //                     to="/services&product"
// //                     className="inline-flex items-center text-green-400 mt-4 hover:underline"
// //                   >
// //                     Learn more →
// //                   </Link>
// //                 </motion.div>
// //               ))}
// //             </div>
// //             <div className="mt-12">
// //               <Link
// //                 to="/services-product"
// //                 className="px-8 py-3 rounded-md border border-green-400 text-green-400 hover:bg-green-900/30 transition"
// //               >
// //                 View All Services
// //               </Link>
// //             </div>
// //           </div>
// //         </section>

// //         {/* Testimonials */}
// //         <section className="py-20 bg-gray-900/60">
// //           <div className="max-w-6xl mx-auto text-center">
// //             <h2 className="text-green-400 uppercase font-semibold">
// //               Testimonials
// //             </h2>
// //             <p className="text-4xl font-bold mt-2 mb-12 text-white">
// //               What Clients Say
// //             </p>
// //             <div className="grid md:grid-cols-3 gap-8">
// //               {testimonials.map((t) => (
// //                 <motion.div
// //                   key={t.id}
// //                   whileHover={{ y: -8 }}
// //                   className="p-8 rounded-xl bg-gray-800/60 border border-gray-700 shadow-lg hover:border-green-400 transition backdrop-blur-sm"
// //                 >
// //                   <p className="italic text-gray-100">"{t.text}"</p>
// //                   <div className="mt-4 text-green-400 font-semibold">
// //                     {t.name}
// //                   </div>
// //                   <p className="text-gray-200 text-sm">{t.company}</p>
// //                 </motion.div>
// //               ))}
// //             </div>
// //           </div>
// //         </section>

// //         {/* CTA */}
// //         <section className="py-20">
// //           <div className="max-w-4xl mx-auto text-center bg-gradient-to-r from-green-800/40 to-gray-900/60 p-12 rounded-2xl border border-gray-700 shadow-xl backdrop-blur-sm">
// //             <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
// //               Ready to Transform Your Business?
// //             </h2>
// //             <p className="text-lg text-gray-100 mb-8">
// //               Let's discuss how Quadrangle can help you achieve growth &
// //               efficiency.
// //             </p>
// //             <div className="flex flex-col sm:flex-row gap-4 justify-center">
// //               <Link
// //                 to="/contact"
// //                 className="px-8 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 transition"
// //               >
// //                 Contact Us
// //               </Link>
// //               {/* <Link
// //                 to="/case-studies"
// //                 className="px-8 py-3 border border-green-400 text-green-400 rounded-md hover:bg-green-900/30 transition"
// //               >
// //                 View Case Studies
// //               </Link> */}
// //             </div>
// //           </div>
// //         </section>
// //       </div>

// //       {/* Float animation */}
// //       <style jsx>{`
// //         @keyframes float {
// //           0%,
// //           100% {
// //             transform: translateY(0) rotate(0deg);
// //           }
// //           50% {
// //             transform: translateY(-20px) rotate(5deg);
// //           }
// //         }
// //         .animate-float {
// //           animation: float 8s ease-in-out infinite;
// //         }
// //       `}</style>
// //     </div>
// //   );
// // };

// // export default Home;

// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import { Helmet } from "react-helmet-async"; // ✅ SEO
// import Hero from "../components/hero";
// import AboutUs from "../components/Aboutus";

// const Home = () => {
//   const [selectedService, setSelectedService] = useState(null);

//   // Why Choose Us
//   const whyChooseUs = [
//     {
//       id: 1,
//       title: "15+ Years Experience",
//       desc: "Deep industry knowledge in shipping & logistics",
//       icon: "📅",
//     },
//     {
//       id: 2,
//       title: "Global Client Base",
//       desc: "Trusted across multiple continents",
//       icon: "🌎",
//     },
//     {
//       id: 3,
//       title: "Custom Solutions",
//       desc: "Tailored software for your business",
//       icon: "🛠️",
//     },
//     {
//       id: 4,
//       title: "24/7 Support",
//       desc: "Round-the-clock assistance",
//       icon: "🔧",
//     },
//   ];

//   // Services
//   const services = [
//     {
//       id: 1,
//       title: "Custom Documentation Automation",
//       desc: "EMAN & ASYCUDA format solutions. Automate customs documentation with scalable, country-specific compliance.",
//       icon: "📑",
//       details:
//         "Our Custom Documentation Automation system ensures compliance with EMAN and ASYCUDA standards. It streamlines customs paperwork, reduces manual errors, and adapts to country-specific requirements. This improves accuracy, compliance, and operational speed for international trade documentation.",
//     },
//     {
//       id: 2,
//       title: "Operations Management Software",
//       desc: "Sales, Purchase, Delivery Orders & Invoicing. Streamline and digitize day-to-day operations with integrated or stand-alone modules.",
//       icon: "📊",
//       details:
//         "The Operations Management Software digitizes your entire workflow, including sales, purchases, delivery orders, and invoicing. It can function as an all-in-one ERP or integrate with your existing tools. With real-time dashboards and reporting, businesses can optimize efficiency, reduce errors, and improve customer satisfaction.",
//     },
//     {
//       id: 3,
//       title: "Freight Forwarding Software",
//       desc: "Booking, Consolidation & Billing. End-to-end freight lifecycle management for air, sea, and land.",
//       icon: "🚢",
//       details:
//         "Our Freight Forwarding Software covers the complete freight lifecycle—booking, consolidation, tracking, and billing—across air, sea, and land shipments. It provides real-time visibility, automated billing, and multi-modal support, helping freight forwarders manage operations more efficiently and reduce delays.",
//     },
//     {
//       id: 4,
//       title: "AI Chatbots & Virtual Assistants",
//       desc: "Enhance customer support and engagement with AI-driven chatbots and virtual assistants.",
//       icon: "🤖",
//       details:
//         "AI Chatbots and Virtual Assistants provide 24/7 customer support, automate FAQs, and assist with order tracking, bookings, and inquiries. With natural language processing, they can integrate into websites, apps, and communication platforms, boosting customer engagement and reducing support costs.",
//     },
//   ];

//   // Testimonials
//   const testimonials = [
//     {
//       id: 1,
//       name: "Ahmed Hassan",
//       company: "",
//       text: "Quadrangle's solutions transformed our port operations, increasing efficiency by 40%.",
//     },
//     {
//       id: 2,
//       name: "Marie Lambert",
//       company: "Global Logistics Inc.",
//       text: "Their software streamlined cargo management across countries.",
//     },
//     {
//       id: 3,
//       name: "John Smith",
//       company: "",
//       text: "The digital transformation saved us annually.",
//     },
//   ];

//   // Core Values
//   const coreValues = [
//     {
//       id: 1,
//       title: "AI Innovation",
//       desc: "Harnessing the power of artificial intelligence to deliver smarter, future-ready solutions.",
//     },
//     {
//       id: 2,
//       title: "Customer Success",
//       desc: "Putting clients at the center of everything we do and enabling their growth through technology.",
//     },
//     {
//       id: 3,
//       title: "Integrity",
//       desc: "Building trust through transparency, accountability, and ethical practices.",
//     },
//     {
//       id: 4,
//       title: "Excellence",
//       desc: "Striving for the highest quality in every solution, service, and interaction.",
//     },
//     {
//       id: 5,
//       title: "Collaboration",
//       desc: "Working as partners with our clients, employees, and stakeholders to achieve shared success.",
//     },
//     {
//       id: 6,
//       title: "Data-Driven Decisions",
//       desc: "Leveraging data and analytics to create intelligent, result-oriented solutions.",
//     },
//   ];

//   return (
//     <div className="text-white overflow-hidden relative">
//       {/* ✅ SEO Helmet */}
//       <Helmet>
//         <title>Quadrangle Solutions | AI & Logistics Software</title>
//         <meta
//           name="description"
//           content="Quadrangle Solutions - AI-powered logistics, freight forwarding, operations management, and custom automation software. Trusted globally with 15+ years of experience."
//         />
//         <meta
//           name="keywords"
//           content="Quadrangle Solutions, Logistics Software, Freight Forwarding, AI Chatbots, Shipping Software, Automation"
//         />
//         <meta
//           property="og:title"
//           content="Quadrangle Solutions | AI & Logistics Software"
//         />
//         <meta
//           property="og:description"
//           content="Empowering shipping & logistics with AI-driven, scalable, and future-ready software solutions."
//         />
//         <meta property="og:url" content="https://quadranglesolutions.com/" />
//         <meta property="og:type" content="website" />
//         <meta
//           property="og:image"
//           content="https://quadranglesolutions.com/og-image.jpg"
//         />
//         <meta
//           property="linkedin:company"
//           content="https://www.linkedin.com/company/quadranglesolutions/"
//         />
//         <link rel="canonical" href="https://quadranglesolutions.com/" />
//       </Helmet>

//       {/* Background */}
//       <div className="absolute inset-0 z-0 overflow-hidden">
//         <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]"></div>
//         <div className="absolute top-0 left-0 w-full h-1/3 bg-gradient-to-b from-emerald-900/10 to-transparent"></div>
//         <div className="absolute bottom-0 left-0 w-full h-1/3 bg-gradient-to-t from-blue-900/10 to-transparent"></div>
//         {[...Array(8)].map((_, i) => (
//           <div
//             key={i}
//             className="absolute rounded-full bg-emerald-500/10 animate-float"
//             style={{
//               width: `${40 + i * 20}px`,
//               height: `${40 + i * 20}px`,
//               top: `${10 + i * 10}%`,
//               left: `${Math.random() * 100}%`,
//               animationDuration: `${15 + i * 5}s`,
//               animationDelay: `${i * 2}s`,
//             }}
//           ></div>
//         ))}
//       </div>

//       {/* Content */}
//       <div className="relative z-10">
//         <Hero />
//         <AboutUs />

//         {/* (⚡ Rest of your sections remain unchanged...) */}
//       </div>
//     </div>
//   );
// };

// export default Home;

import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Helmet } from "react-helmet-async"; // ✅ SEO
import Hero from "../components/hero";
import AboutUs from "../components/Aboutus";

const Home = () => {
  const [selectedService, setSelectedService] = useState(null);

  // Why Choose Us
  const whyChooseUs = [
    {
      id: 1,
      title: "15+ Years Experience",
      desc: "Deep industry knowledge in shipping & logistics",
      icon: "📅",
    },
    {
      id: 2,
      title: "Global Client Base",
      desc: "Trusted across multiple continents",
      icon: "🌎",
    },
    {
      id: 3,
      title: "Custom Solutions",
      desc: "Tailored software for your business",
      icon: "🛠️",
    },
    {
      id: 4,
      title: "24/7 Support",
      desc: "Round-the-clock assistance",
      icon: "🔧",
    },
  ];

  // Services
  const services = [
    {
      id: 1,
      title: "Custom Documentation Automation",
      desc: "EMAN & ASYCUDA format solutions. Automate customs documentation with scalable, country-specific compliance.",
      icon: "📑",
      details:
        "Our Custom Documentation Automation system ensures compliance with EMAN and ASYCUDA standards. It streamlines customs paperwork, reduces manual errors, and adapts to country-specific requirements. This improves accuracy, compliance, and operational speed for international trade documentation.",
    },
    {
      id: 2,
      title: "Operations Management Software",
      desc: "Sales, Purchase, Delivery Orders & Invoicing. Streamline and digitize day-to-day operations with integrated or stand-alone modules.",
      icon: "📊",
      details:
        "The Operations Management Software digitizes your entire workflow, including sales, purchases, delivery orders, and invoicing. It can function as an all-in-one ERP or integrate with your existing tools. With real-time dashboards and reporting, businesses can optimize efficiency, reduce errors, and improve customer satisfaction.",
    },
    {
      id: 3,
      title: "Freight Forwarding Software",
      desc: "Booking, Consolidation & Billing. End-to-end freight lifecycle management for air, sea, and land.",
      icon: "🚢",
      details:
        "Our Freight Forwarding Software covers the complete freight lifecycle—booking, consolidation, tracking, and billing—across air, sea, and land shipments. It provides real-time visibility, automated billing, and multi-modal support, helping freight forwarders manage operations more efficiently and reduce delays.",
    },
    {
      id: 4,
      title: "AI Chatbots & Virtual Assistants",
      desc: "Enhance customer support and engagement with AI-driven chatbots and virtual assistants.",
      icon: "🤖",
      details:
        "AI Chatbots and Virtual Assistants provide 24/7 customer support, automate FAQs, and assist with order tracking, bookings, and inquiries. With natural language processing, they can integrate into websites, apps, and communication platforms, boosting customer engagement and reducing support costs.",
    },
  ];

  // Testimonials
  const testimonials = [
    {
      id: 1,
      name: "Ahmed Hassan",
      company: "",
      text: "Quadrangle's solutions transformed our port operations, increasing efficiency by 40%.",
    },
    {
      id: 2,
      name: "Marie Lambert",
      company: "Global Logistics Inc.",
      text: "Their software streamlined cargo management across countries.",
    },
    {
      id: 3,
      name: "John Smith",
      company: "",
      text: "The digital transformation saved us annually.",
    },
  ];

  // Core Values
  const coreValues = [
    {
      id: 1,
      title: "AI Innovation",
      desc: "Harnessing the power of artificial intelligence to deliver smarter, future-ready solutions.",
    },
    {
      id: 2,
      title: "Customer Success",
      desc: "Putting clients at the center of everything we do and enabling their growth through technology.",
    },
    {
      id: 3,
      title: "Integrity",
      desc: "Building trust through transparency, accountability, and ethical practices.",
    },
    {
      id: 4,
      title: "Excellence",
      desc: "Striving for the highest quality in every solution, service, and interaction.",
    },
    {
      id: 5,
      title: "Collaboration",
      desc: "Working as partners with our clients, employees, and stakeholders to achieve shared success.",
    },
    {
      id: 6,
      title: "Data-Driven Decisions",
      desc: "Leveraging data and analytics to create intelligent, result-oriented solutions.",
    },
  ];

  return (
    <div className="text-white overflow-hidden relative">
      {/* ✅ SEO Helmet */}
      <Helmet>
        <title>Quadrangle Solutions | AI & Logistics Software</title>
        <meta
          name="description"
          content="Quadrangle Solutions - AI-powered logistics, freight forwarding, operations management, and custom automation software. Trusted globally with 15+ years of experience."
        />
        <meta
          name="keywords"
          content="Quadrangle Solutions, Logistics Software, Freight Forwarding, AI Chatbots, Shipping Software, Automation"
        />
        <meta
          property="og:title"
          content="Quadrangle Solutions | AI & Logistics Software"
        />
        <meta
          property="og:description"
          content="Empowering shipping & logistics with AI-driven, scalable, and future-ready software solutions."
        />
        <meta property="og:url" content="https://quadranglesolutions.com/" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://quadranglesolutions.com/og-image.jpg"
        />
        <meta
          property="linkedin:company"
          content="https://www.linkedin.com/company/quadranglesolutions/"
        />
        <link rel="canonical" href="https://quadranglesolutions.com/" />
      </Helmet>

      {/* Background */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]"></div>
        <div className="absolute top-0 left-0 w-full h-1/3 bg-gradient-to-b from-emerald-900/10 to-transparent"></div>
        <div className="absolute bottom-0 left-0 w-full h-1/3 bg-gradient-to-t from-blue-900/10 to-transparent"></div>
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="absolute rounded-full bg-emerald-500/10 animate-float"
            style={{
              width: `${40 + i * 20}px`,
              height: `${40 + i * 20}px`,
              top: `${10 + i * 10}%`,
              left: `${Math.random() * 100}%`,
              animationDuration: `${15 + i * 5}s`,
              animationDelay: `${i * 2}s`,
            }}
          ></div>
        ))}
      </div>

      {/* Content */}
      <div className="relative z-10">
        <Hero />
        <AboutUs />

        {/* Vision & Mission */}
        <section className="py-20">
          <div className="max-w-5xl mx-auto text-center space-y-12">
            <motion.div
              whileHover={{ scale: 1.02 }}
              className="bg-gray-800/60 p-10 rounded-2xl border border-gray-700 shadow-lg backdrop-blur-sm"
            >
              <h2 className="text-green-400 uppercase font-semibold">
                {" "}
                Vision Statement{" "}
              </h2>
              <p className="mt-4 text-xl text-gray-100 leading-relaxed">
                To be a globally trusted technology partner, empowering
                businesses in shipping, logistics, and beyond with AI-driven,
                scalable, and future-ready software solutions that drive
                efficiency, reliability, and growth.
              </p>
            </motion.div>
            <motion.div
              whileHover={{ scale: 1.02 }}
              className="bg-gray-800/60 p-10 rounded-2xl border border-gray-700 shadow-lg backdrop-blur-sm"
            >
              <h2 className="text-green-400 uppercase font-semibold">
                {" "}
                Mission Statement{" "}
              </h2>
              <p className="mt-4 text-xl text-gray-100 leading-relaxed">
                Our mission is to bridge the gap between industry challenges and
                technology by delivering AI-powered IT solutions that simplify
                complex operations, enhance productivity, and create long-term
                value for our clients. Guided by innovation, integrity, and
                customer-centricity, we strive to transform logistics and allied
                industries into smarter, more connected ecosystems.
              </p>
            </motion.div>
          </div>
        </section>

        {/* Core Values */}
        <section className="py-20 bg-gray-900/60">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-green-400 uppercase font-semibold mb-12">
              {" "}
              Core Values{" "}
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {coreValues.map((value) => (
                <motion.div
                  key={value.id}
                  whileHover={{ y: -6 }}
                  className="p-8 bg-gray-800/60 rounded-xl border border-gray-700 shadow-md hover:border-green-400 transition backdrop-blur-sm"
                >
                  <h3 className="text-xl font-bold text-white">
                    {" "}
                    {value.title}{" "}
                  </h3>
                  <p className="text-gray-100 mt-3 text-base">{value.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="py-20">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-green-400 font-semibold uppercase">
              {" "}
              Why Choose Us{" "}
            </h2>
            <p className="text-4xl font-bold mt-2 mb-12 text-green-400">
              {" "}
              The Quadrangle Advantage{" "}
            </p>
            <div className="grid md:grid-cols-4 gap-8">
              {whyChooseUs.map((w) => (
                <motion.div
                  key={w.id}
                  whileHover={{ y: -8 }}
                  className="p-8 rounded-xl bg-gray-800/60 border border-gray-700 shadow-md hover:border-green-400 transition backdrop-blur-sm"
                >
                  <div className="text-4xl mb-4">{w.icon}</div>
                  <h3 className="text-lg font-bold text-white">{w.title}</h3>
                  <p className="text-gray-100 text-sm mt-2">{w.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Services */}
        <section className="py-20 bg-gradient-to-br from-green-900/20 to-transparent">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-green-400 uppercase font-semibold">
              {" "}
              Product & Services{" "}
            </h2>
            <p className="text-4xl font-bold mt-2 mb-12 text-white">
              {" "}
              Solutions for Your Business{" "}
            </p>
            <div className="grid md:grid-cols-2 gap-10">
              {services.map((s) => (
                <motion.div
                  key={s.id}
                  whileHover={{ scale: 1.03 }}
                  className="p-8 rounded-xl bg-gray-800/60 border border-gray-700 text-left shadow-md hover:border-green-400 transition backdrop-blur-sm"
                >
                  <div className="text-3xl text-green-400">{s.icon}</div>
                  <h3 className="text-xl font-bold mt-3 text-white">
                    {" "}
                    {s.title}{" "}
                  </h3>
                  <p className="text-gray-100 mt-2">{s.desc}</p>
                  <button
                    onClick={() => setSelectedService(s)}
                    className="inline-flex items-center text-green-400 mt-4 hover:underline"
                  >
                    Learn more →
                  </button>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="py-20 bg-gray-900/60">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-green-400 uppercase font-semibold">
              {" "}
              Testimonials{" "}
            </h2>
            <p className="text-4xl font-bold mt-2 mb-12 text-white">
              {" "}
              What Clients Say{" "}
            </p>
            <div className="grid md:grid-cols-3 gap-8">
              {testimonials.map((t) => (
                <motion.div
                  key={t.id}
                  whileHover={{ y: -8 }}
                  className="p-8 rounded-xl bg-gray-800/60 border border-gray-700 shadow-lg hover:border-green-400 transition backdrop-blur-sm"
                >
                  <p className="italic text-gray-100">"{t.text}"</p>
                  <div className="mt-4 text-green-400 font-semibold">
                    {" "}
                    {t.name}{" "}
                  </div>
                  <p className="text-gray-200 text-sm">{t.company}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-20">
          <div className="max-w-4xl mx-auto text-center bg-gradient-to-r from-green-800/40 to-gray-900/60 p-12 rounded-2xl border border-gray-700 shadow-xl backdrop-blur-sm">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
              {" "}
              Ready to Transform Your Business?{" "}
            </h2>
            <p className="text-lg text-gray-100 mb-8">
              Let's discuss how Quadrangle can help you achieve growth &
              efficiency.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="px-8 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 transition"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </section>
      </div>

      {/* Modal */}
      <AnimatePresence>
        {selectedService && (
          <motion.div
            className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="bg-gray-900 p-8 rounded-2xl max-w-lg w-full border border-green-400 shadow-xl relative overflow-y-auto max-h-[80vh]"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
            >
              <button
                onClick={() => setSelectedService(null)}
                className="absolute top-3 right-3 text-gray-400 hover:text-white"
              >
                ✖
              </button>
              <div className="text-4xl mb-4">{selectedService.icon}</div>
              <h3 className="text-2xl font-bold text-green-400">
                {" "}
                {selectedService.title}{" "}
              </h3>
              <p className="text-gray-100 mt-4 leading-relaxed">
                {" "}
                {selectedService.details}{" "}
              </p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Float animation */}
      <style jsx>{`
        @keyframes float {
          0%,
          100% {
            transform: translateY(0) rotate(0deg);
          }
          50% {
            transform: translateY(-20px) rotate(5deg);
          }
        }
        .animate-float {
          animation: float 8s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default Home;
